import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskLines, Overline, Reveal } from "../site/Motion";

const PRINCIPLES = [
  ["One contract", "Manpower, payroll, records and logistics under a single agreement and invoice."],
  ["Compliance first", "Wages, PF, ESIC and statutory registers handled properly, every month."],
  ["Owner-level accountability", "Escalations reach the director's desk — not a call-centre queue."],
];

export const Director = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="director" ref={ref} className="relative overflow-hidden bg-[var(--ink)] py-24 md:py-36" data-testid="director-section">
      <div className="mx-auto grid max-w-[1440px] gap-14 px-5 md:px-10 lg:grid-cols-12">
        <div className="relative lg:col-span-5">
          <div className="clip-notch relative aspect-[4/5] overflow-hidden bg-[var(--ink-2)]">
            <motion.img src="/img/crew.jpg" alt="BHISM field team" style={{ y, scale: 1.25 }} className="h-full w-full object-cover grayscale" />
            <div className="absolute inset-0 bg-[rgba(255,176,0,0.12)] mix-blend-multiply" />
          </div>
          <p aria-hidden="true" className="absolute -bottom-10 -right-2 font-display text-[9rem] font-black leading-none text-outline-signal md:text-[12rem]">BS</p>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Overline>The company</Overline>
          <MaskLines lines={["Built on", "a promise", "kept daily."]}
            className="mt-6 font-display text-5xl font-black uppercase leading-[0.9] md:text-7xl"
            lineClass={(i) => (i === 2 ? "text-[var(--signal)]" : "")} />
          <Reveal delay={0.1}>
            <blockquote className="mt-10 border-l-2 border-[var(--signal)] pl-6 text-lg text-[var(--bone)] md:text-xl" data-testid="director-message">
              “Our job is to take the operational load off your shoulders — the right people on site, salaries paid on time, records in order and goods where they should be.”
            </blockquote>
            <p className="mt-5 font-display text-2xl font-extrabold uppercase" data-testid="director-name">Brijpal Singh</p>
            <p className="overline text-[var(--bone-2)]">Director, BHISM Infratech Pvt. Ltd.</p>
          </Reveal>
          <div className="mt-14 grid gap-px bg-white/10 sm:grid-cols-3">
            {PRINCIPLES.map(([t, d], i) => (
              <Reveal key={t} delay={i * 0.1} className="bg-[var(--ink)] p-5 sm:pr-6">
                <p className="font-mono text-xs text-[var(--signal)]">0{i + 1}</p>
                <h3 className="mt-3 font-display text-2xl font-extrabold uppercase leading-none">{t}</h3>
                <p className="mt-3 text-sm text-[var(--bone-2)]">{d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
